export const BASIC_PLAN_ID = 'free_plan';
export const ITUNES_PLAN_ID = 'itunes_plan';
export const LEGACY_PLAN_ID = 'legacy_plan';
export const MANUAL_PLAN_ID = 'manual_plan';
export const PRO_PLAN_ID = 'pro_plan';
export const PREMIUM_PLAN_ID = 'premium_plan';
export const ELITE_PLAN_ID = 'elite_plan';

export const SCHEMES = {
  UNIT: 'UNIT',
  TIERED: 'TIERED',
  ITUNES: 'ITUNES',
} as const;

export const ALT_PLANS = [
  BASIC_PLAN_ID,
  ITUNES_PLAN_ID,
  LEGACY_PLAN_ID,
  MANUAL_PLAN_ID,
];
export const PAYMENT_METHOD_BRAND_VISA = 'Visa';
export const PAYMENT_METHOD_BRAND_MASTERCARD = 'MasterCard';
export const PAYMENT_METHOD_BRAND_DISCOVER = 'Discover';
export const PAYMENT_METHOD_BRAND_AMEX = 'Amex';
export const PAYMENT_METHOD_ACH = 'bank_account';
export const PAYMENT_METHOD_CARD = 'card';
export const PAYMENT_METHOD_LINK = 'link';

export const V3_PLAN_IDS = [
  '149-base-34-user',
  '1548-base-348-user-annual',
  '948-base-annual-348-user',
  '99-base-34-user',
  '249-base-34-user',
  '2388-base-348-user-annual',
] as const;
